import React, { useState, useEffect } from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';

const benefits = [
  { 
    title: "挑战顶级竞赛", 
    desc: "每月参与3-4场高水平竞赛，涵盖阿里云CTF、强网杯、DEF CON等知名赛事。线下赛机票、住宿全额报销，比赛奖金由队员自由分配，让你专注于技术突破。"
  },
  { 
    title: "职业发展机会", 
    desc: "腾讯、阿里、字节、美团等知名企业及政府部门均有御林学长的身影。你将获得宝贵的内推实习机会，一对一经验分享和特殊招聘通道，为你的职业发展铺平道路。"
  },
  { 
    title: "学术深造指导", 
    desc: "工作室成员涵盖本科、硕士和博士各阶段，部分成员远赴海内外知名院校深造。在这里你可以与学长们深入交流保研、留学、导师选择等宝贵经验，助力学术成长。"
  },
  { 
    title: "温暖的团队氛围", 
    desc: "一起打比赛、聚餐、开黑，各专业学长学姐为你提供全方位支持。无论是选课指导、专业面试，还是学习生活问题，这里永远有人陪伴你。"
  },
];

function BenefitsSection() {
  const [sectionRef, isSectionVisible] = useScrollAnimation(0.1);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % benefits.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <section ref={sectionRef} className="section benefits" aria-labelledby="benefits-title" style={{
      opacity: isSectionVisible ? 1 : 0,
      transform: isSectionVisible ? 'translateY(0)' : 'translateY(50px)',
      transition: 'all 1s cubic-bezier(0.23, 1, 0.32, 1)',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      margin: '0',
      paddingTop: '0',
      paddingBottom: '0'
    }}>
      <div style={{ 
        position: 'relative',
        height: '400px',
        width: '100%'
      }}>
        {benefits.map((benefit, index) => (
          <div
            key={index}
            style={{
              position: 'absolute',
              inset: 0,
              opacity: index === currentIndex ?1 : 0,
              transform: index === currentIndex ? 'translateX(0)' : 'translateX(30px)',
              transition: 'all 0.6s cubic-bezier(0.23, 1, 0.32, 1)',
              pointerEvents: index === currentIndex ? 'auto' : 'none',
              display: 'flex',
              flexDirection: 'column',
              padding: 'var(--space-8)'
            }}
          >
            <h3 
              style={{
                fontSize: '2rem',
                marginBottom: 'var(--space-6)',
                background: 'var(--gradient-brand)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >
              {benefit.title}
            </h3>
            
            <p 
              style={{
                flex: 1,
                lineHeight: 'var(--leading-relaxed)',
                fontSize: '1.2rem',
                color: 'var(--text-secondary)'
              }}
            >
              {benefit.desc}
            </p>
            
            <div 
              style={{
                height: '3px',
                background: 'linear-gradient(90deg, #FF6B35, transparent)',
                borderRadius: '2px',
                marginTop: 'var(--space-6)'
              }}
            />
          </div>
        ))}

        <div style={{
          display: 'flex',
          gap: 'var(--space-3)',
          justifyContent: 'center',
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)'
        }}>
          {benefits.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              style={{
                width: index === currentIndex ? '32px' : '12px',
                height: '12px',
                borderRadius: '6px',
                background: index === currentIndex 
                  ? 'var(--gradient-brand)' 
                  : 'rgba(255, 107, 53, 0.3)',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default BenefitsSection;